import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { ArtistId } from '../models/artist.model'
import { Observable } from 'rxjs'
import { Reactions } from '../models/reactions.model'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class ReactionsGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findReactionsGraph(artistId: ArtistId, from: Date, to: Date): Observable<Reactions[]> {
    return this.functions.httpsCallable<
      { artistId: string; from: string; to: string },
      Reactions[]
    >('findReactionsGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
